import Link from 'next/link';

import { useTrackViewedWorkspaceSettings } from '@air/analytics';
import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { SettingsIcon } from '@air/design-icons';

import { Routes } from '~/constants/routes';
import { useIsActiveRoute } from '~/hooks/useIsActiveRoute';

export const SidebarNavigationItemWorkspaceSettings = () => {
  const { isActiveRoute } = useIsActiveRoute({ route: Routes.workspaceSettings.root });
  const { trackViewedWorkspaceSettings } = useTrackViewedWorkspaceSettings();

  return (
    <SidebarNavigationItem
      asChild
      data-id="workspace-settings"
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={() => trackViewedWorkspaceSettings({ location: 'current-workspace-nav' })}
      prefix={<SettingsIcon size="sm" />}
      state={isActiveRoute ? 'active' : 'default'}
    >
      <Link href={Routes.workspaceSettings.members}>Settings & users</Link>
    </SidebarNavigationItem>
  );
};
